import { useDispatch, useSelector } from "react-redux";

import AntallIleggelserPerIleggelsetypeFilterForm from "./AntallIleggelserPerIleggelsetypeFilterForm";

import {
  handleChange as handleChangeAction,
  handleChangeAll as handleChangeAllAction,
  handleChangeToInitState as handleChangeToInitStateAction,
} from "../../../actions/handleChangeAction";
import { getAntallIleggelserPerIleggelsetype as getAntallIleggelserPerIleggelsetypeAction } from "../../../actions/rapporter/antallIleggelserPerIleggelsetypeActions";

function AntallIleggelserPerIleggelsetypeFilterFormContainer(ownProps) {
  const dispatch = useDispatch();
  const antallIleggelserPerIleggelsetypeFilterForm = useSelector(
    (state) => state.forms.antallIleggelserPerIleggelsetypeFilterForm,
  );

  return (
    <AntallIleggelserPerIleggelsetypeFilterForm
      {...ownProps}
      antallIleggelserPerIleggelsetypeFilterForm={
        antallIleggelserPerIleggelsetypeFilterForm
      }
      handleChange={(variableName, value) =>
        dispatch(
          handleChangeAction(
            "RAPPORT_ANTALL_ILEGGELSER_PER_ILEGGELSETYPE_FILTER_FORM",
            variableName,
            value,
          ),
        )
      }
      handleChangeAll={(reducerName, payload) =>
        dispatch(handleChangeAllAction(reducerName, payload))
      }
      handleChangeToInitState={(actionType) =>
        dispatch(handleChangeToInitStateAction(actionType))
      }
      getAntallIleggelserPerIleggelsetype={(params) =>
        dispatch(getAntallIleggelserPerIleggelsetypeAction(params))
      }
    />
  );
}

export default AntallIleggelserPerIleggelsetypeFilterFormContainer;
